import React from "react";
import PropTypes from "prop-types";

import validator from "validator";

export function PrivateEmbeddedInsight({ embedUrl, title, height, width }) {
  if (!validator.isURL(embedUrl)) {
    console.error(`Report embed url ${embedUrl} is invalid`);

    return (
      <span>
        The report is not available at the moment. Please contact support for
        assistance.
      </span>
    );
  }

  return (
    <iframe
      data-test="insight-iframe"
      src={embedUrl}
      title={title}
      style={{ border: 0, height: height, width: width }}
    />
  );
}

PrivateEmbeddedInsight.propTypes = {
  embedUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

PrivateEmbeddedInsight.defaultProps = {
  title: "Reports",
  height: "inherit",
  width: "inherit",
};

export default PrivateEmbeddedInsight;
